const mobileUtils = {
  Android: function() {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function() {
    return navigator.userAgent.match(/BlackBerry|BB10/i);
  },
  iOS: function() {
    return (navigator.userAgent.match(/iPhone|iPod|iPad/i) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
        !window.MSStream;
  },
  Opera: function() {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function() {
    return navigator.userAgent.match(/IEMobile/i);
  },
  // iPad 및 태블릿 해상도 감지
  isTabletResolution: function() {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    // iPad 및 태블릿 해상도들 (가로/세로 모두 고려)
    const tabletResolutions = [
      // iPad Air
      {w: 820, h: 1180},
      {w: 1180, h: 820},
      // iPad Pro 11"
      {w: 1024, h: 1366},
      {w: 1366, h: 1024},
      // iPad Pro 12.9"
      {w: 1024, h: 1366},
      {w: 1366, h: 1024},
      // 기타 태블릿 해상도들
      {w: 768, h: 1024},
      {w: 1024, h: 768},
      { w: 810, h: 1080 },
      { w: 1080, h: 810 }
    ];

    return tabletResolutions.some(res =>
        (width === res.w && height === res.h) ||
        (width === res.h && height === res.w)
    );
  },
  isMobileResolution: function() {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    // 태블릿 해상도 체크 (우선)
    if (this.isTabletResolution()) {
      return true;
    }

    // 일반 모바일 해상도 (768px 이하)
    return width <= 1366;
  },
  any: function() {
    return this.isMobileResolution() ||
        this.Android() ||
        this.BlackBerry() ||
        this.iOS() ||
        this.Opera() ||
        this.Windows();
  }
}

export default mobileUtils;